import "./CheckoutPage.css";

import React from "react";

import { useEffect, useState } from "react";

import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Rating from "@mui/material/Rating";
import CheckIcon from "@mui/icons-material/Check";

import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

export const CheckoutPage = ({
  changeNavBar,
  cartContent,
  subtotalValue,
  handleEmptyCart,
}) => {
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState("");
  const [modalText, setModalText] = useState("");

  const [siteCommentFormShown, setSiteCommentFormShown] = useState(false);
  const [commentValue, setCommentValue] = useState("");
  const [value, setValue] = useState(0);

  const [isOrderResponse, setIsOrderResponse] = useState(false);
  const [modalTextColor, setModalTextColor] = useState("");

  const [firstNameValue, setFirstNameValue] = useState("");
  const [familyNameValue, setFamilyNameValue] = useState("");
  const [phoneValue, setPhoneValue] = useState("");
  const [cityValue, setCityValue] = useState("");
  const [postalCodeValue, setPostalCodeValue] = useState("");
  const [ekontAdressValue, setEkontAdressValue] = useState("");
  const [adressValue, setAdressValue] = useState("");
  const [extraInfo, setExtraInfo] = useState("");

  const [formVariant, setFormVariant] = useState(2);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setSiteCommentFormShown(false);
    setIsOrderResponse(false);
    setOpen(false);
    if (siteCommentFormShown === true) {
      let reqInfo = {
        rating: value,
        name: `${firstNameValue} ${familyNameValue}`,
        phone: phoneValue,
        comment: commentValue,
      };
      fetch(
        "https://us-central1-viko-admin-07.cloudfunctions.net/setNewComment",
        {
          method: "POST",

          body: JSON.stringify(reqInfo),
        }
      ).then(() => {
        setSiteCommentFormShown(false);
      });

      // addDoc(collection(fireStrore, "Comments"), {
      //   rating: value,
      //   name: `${firstNameValue} ${familyNameValue}`,
      //   phone: phoneValue,
      //   comment: commentValue,
      // }).then(() => {
      //   setSiteCommentFormShown(false);
      // });
    }
  };

  const handleChangeCommentField = (e) => {
    setCommentValue(e.target.value);
  };
  const handleAdressForm = (e) => {
    setFormVariant(1);
  };

  const handleOfficeForm = (e) => {
    setFormVariant(2);
  };

  const handleFirstNameValue = (e) => {
    setFirstNameValue(e.target.value);
  };
  const handleFamilyNameValue = (e) => {
    setFamilyNameValue(e.target.value);
  };
  const handlePhoneValue = (e) => {
    setPhoneValue(e.target.value);
  };
  const handleCityValue = (e) => {
    setCityValue(e.target.value);
  };
  const handlePostalCodeValue = (e) => {
    setPostalCodeValue(e.target.value);
  };
  const handleEkontAdressValue = (e) => {
    setEkontAdressValue(e.target.value);
  };
  const handleAdressValue = (e) => {
    setAdressValue(e.target.value);
  };
  const handleExtraInfoValue = (e) => {
    setExtraInfo(e.target.value);
  };

  const handleCheckoutSubmit = () => {
    if (cartContent.length === 0) {
      setIsOrderResponse(false);
      setModalText("Количката е празна");
      setOpen(true);
    } else if (
      firstNameValue === "" ||
      familyNameValue === "" ||
      phoneValue === "" ||
      cityValue === "" ||
      postalCodeValue === "" ||
      (formVariant === 2 ? ekontAdressValue === "" : adressValue === "")
    ) {
      setIsOrderResponse(false);
      setModalText("Моля попълнете червените полета");
      setOpen(true);
    } else {
      setIsLoading(true);
      let reqInfo = `
        <p> Метод на доставка: ${
          formVariant === 2 ? "До Офис на ЕКОНТ" : "До ПОСОЧЕН АДРЕС"
        }</p>
        <p> Град: ${cityValue}</p>
        <p> Адрес: ${formVariant === 2 ? ekontAdressValue : adressValue}</p>
        <p> Име: ${firstNameValue} ${familyNameValue}</p>
        <p> Телефон: ${phoneValue}</p>
        
        <p> Пощенски код: ${postalCodeValue}</p>
        <p>Допълнителна информация: ${extraInfo}</p>
        <p> -----------------------------------------------------------</p>
        
        ${cartContent.map((item) => {
          return `<ul>
              <li><img src=${item.imgSrc}></img></li>
              <li>${item.name}</li>
              <li>броя: ${item.count}</li>
              <li>единична цена: ${item.price} лв.</li>
              <li>комбинирана цена: ${
                Number(item.price) * Number(item.count)
              } лв.</li>
              <li>--------------------------------</li>
            </ul>`;
        })}
        <p>Обща цена на поръчката: ${subtotalValue} лв.</p>
      `;

      fetch(
        "https://us-central1-viko-admin-07.cloudfunctions.net/orderSubmit",
        {
          method: "POST",

          body: JSON.stringify(reqInfo),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          if (result.resultObj === "success") {
            setModalTextColor("green");
            setIsOrderResponse(true);
            setSiteCommentFormShown(true);
            setModalText("Поръчката ви е приета !");
            setIsLoading(false);
            setOpen(true);
            handleEmptyCart();
          } else {
            setModalTextColor("red");
            setIsOrderResponse(true);
            console.log(result);
            setModalText(
              "Нещо се обърка, извиняваме се за неудобството.Моля опитайте отново."
            );
            setIsLoading(false);
            setOpen(true);
          }
        });
    }
  };
  useEffect(() => {
    let href = window.location.href;
    let subHref = href.split("/")[3];
    if (subHref === "checkout") {
      changeNavBar("checkout", "rgba(41, 41, 41)", "white", "13rem", "row");
      // changeNavBar("", "rgba(41, 41, 41)", "white", "black");
    }
  }, []);

  return (
    <div className="checkout-page-container">
      <div className="checkout-title-section">
        <h1 className="checkout-title">Поръчка</h1>
      </div>
      <h1 className="checkout-form-title">Информация за поръчката</h1>
      <div className="checkout-form-container">
        <div className="checkout-form-switch-buttons-container">
          <button
            style={{
              backgroundColor: formVariant === 1 ? "rgb(41, 41, 41)" : "white",
              color: formVariant === 1 ? "white" : "rgb(41, 41, 41)",
            }}
            className="checkout-form-to-office-btn"
            onClick={handleOfficeForm}
          >
            До офис на ЕКОНТ
          </button>
          <button
            style={{
              backgroundColor: formVariant === 1 ? "white" : "rgb(41, 41, 41)",
              color: formVariant === 1 ? "rgb(41, 41, 41)" : "white",
            }}
            className="checkout-form-to-adress-btn"
            onClick={handleAdressForm}
          >
            До адрес
          </button>
        </div>

        {formVariant === 1 ? (
          <div className="checkout-toAdress">
            <TextField
              onChange={handleFirstNameValue}
              error={firstNameValue === "" ? true : false}
              id="outlined-basic"
              label="Име *"
              variant="outlined"
            />
            <TextField
              onChange={handleFamilyNameValue}
              error={familyNameValue === "" ? true : false}
              id="outlined-basic"
              label="Фамилия *"
              variant="outlined"
            />
            <TextField
              onChange={handlePhoneValue}
              error={phoneValue === "" ? true : false}
              id="outlined-basic"
              label="Телефон *"
              variant="outlined"
            />
            <TextField
              onChange={handleCityValue}
              error={cityValue === "" ? true : false}
              id="outlined-basic"
              label="Град *"
              variant="outlined"
            />
            <TextField
              onChange={handlePostalCodeValue}
              error={postalCodeValue === "" ? true : false}
              id="outlined-basic"
              label="Пощенски код *"
              variant="outlined"
            />

            <TextField
              value={adressValue}
              onChange={handleAdressValue}
              error={adressValue === "" ? true : false}
              id="outlined-basic"
              label="Адрес *"
              variant="outlined"
            />
            <TextField
              onChange={handleExtraInfoValue}
              id="outlined-basic"
              label="Допълнителна информация"
              variant="outlined"
            />
          </div>
        ) : (
          <div className="checkout-toOffice">
            <TextField
              onChange={handleFirstNameValue}
              error={firstNameValue === "" ? true : false}
              id="outlined-basic"
              label="Име *"
              variant="outlined"
            />
            <TextField
              onChange={handleFamilyNameValue}
              error={familyNameValue === "" ? true : false}
              id="outlined-basic"
              label="Фамилия *"
              variant="outlined"
            />
            <TextField
              onChange={handlePhoneValue}
              error={phoneValue === "" ? true : false}
              id="outlined-basic"
              label="Телефон *"
              variant="outlined"
            />
            <TextField
              onChange={handleCityValue}
              error={cityValue === "" ? true : false}
              id="outlined-basic"
              label="Град *"
              variant="outlined"
            />
            <TextField
              onChange={handlePostalCodeValue}
              error={postalCodeValue === "" ? true : false}
              id="outlined-basic"
              label="Пощенски код *"
              variant="outlined"
            />
            <TextField
              value={ekontAdressValue}
              onChange={handleEkontAdressValue}
              error={ekontAdressValue === "" ? true : false}
              id="outlined-basic"
              label="Офис на ЕКОНТ *"
              variant="outlined"
            />
            <TextField
              onChange={handleExtraInfoValue}
              multiline
              maxRows={4}
              id="outlined-basic"
              label="Допълнителна информация"
              variant="outlined"
            />
          </div>
        )}
      </div>
      <button
        style={{
          opacity: isLoading === true ? "50%" : "100%",
          pointerEvents: isLoading === true ? "none" : "all",
        }}
        className="checkout-form-button"
        onClick={handleCheckoutSubmit}
      >
        {isLoading === true ? (
          <CircularProgress size={"25px"} sx={{ color: "white" }} />
        ) : (
          "Завърши поръчката"
        )}
      </button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {isOrderResponse === true ? (
            <>
              <Typography
                sx={{ color: modalTextColor, textAlign: "center" }}
                id="modal-modal-title"
                variant="h6"
                component="h2"
              >
                {modalText}
              </Typography>
              {siteCommentFormShown === true ? (
                <div
                  style={{
                    marginTop: "0.5rem",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                  >
                    Моля поставете оценка на нашият сайт.
                  </Typography>
                  <Rating
                    sx={{
                      marginTop: "1rem",
                      marginBottom: "1rem",
                      width: "8rem",
                    }}
                    name="simple-controlled"
                    value={value}
                    onChange={(event, newValue) => {
                      setValue(newValue);
                    }}
                  />
                  <TextField
                    sx={{ width: "90%" }}
                    onChange={handleChangeCommentField}
                    multiline
                    maxRows={4}
                    id="outlined-basic"
                    label="Допълнителен коментар"
                    variant="outlined"
                  />
                </div>
              ) : (
                <></>
              )}
            </>
          ) : (
            <Typography
              sx={{ color: "red", textAlign: "center" }}
              id="modal-modal-title"
              variant="h6"
              component="h2"
            >
              {modalText}
            </Typography>
          )}
          <button onClick={handleClose} className="checkout-modal-close-button">
            <CheckIcon />
          </button>
        </Box>
      </Modal>
    </div>
  );
};
